import React, { useEffect, useState } from "react";
import axios from "axios";
import { Button } from "../ui/button";
import { toast } from "react-toastify";

import SelectField from "../ui/SelectField";

const ModalReporteCronograma = ({ onClose }) => {
  const [clientes, setClientes] = useState([]);
  const [sedes, setSedes] = useState([]);
  const [areas, setAreas] = useState([]);

  const [clienteId, setClienteId] = useState("");
  const [sedeId, setSedeId] = useState("");
  const [areaId, setAreaId] = useState("");
  const [isLoading, setIsLoading] = useState(false);

  const API = process.env.REACT_APP_API_URL;
  const token = localStorage.getItem("token");

  // 🧩 Clientes
  useEffect(() => {
    const fetchClientes = async () => {
      try {
        const res = await axios.get(`${API}/clientes`, {
          headers: { Authorization: `Bearer ${token}` },
        });
        setClientes(res.data);
      } catch {
        toast.error("Error al cargar clientes");
      }
    };
    fetchClientes();
  }, [API, token]);

  // 🧩 Sedes
  useEffect(() => {
    if (!clienteId) return;
    const fetchSedes = async () => {
      try {
        const res = await axios.get(`${API}/sedes/${clienteId}`, {
          headers: { Authorization: `Bearer ${token}` },
        });
        setSedes([{ _id: "all", name: "Todas las sedes" }, ...res.data]);
      } catch {
        toast.error("Error al cargar sedes");
      }
    };
    fetchSedes();
  }, [clienteId, API, token]);

  // 🧩 Áreas
  useEffect(() => {
    if (!clienteId) return;
    const fetchAreas = async () => {
      try {
        const url = `${API}/areas/con_equipos?cliente=${clienteId}&sede=${
          sedeId || "all"
        }`;
        const res = await axios.get(url, {
          headers: { Authorization: `Bearer ${token}` },
        });
        setAreas([{ _id: "all", name: "Todas las áreas" }, ...res.data]);
      } catch {
        toast.error("Error al cargar áreas");
      }
    };
    fetchAreas();
  }, [clienteId, sedeId, API, token]);

  // 🔑 Handler genérico compatible con SelectField
  const handleChange = (e) => {
    const { name, value } = e.target;

    if (name === "cliente") {
      setClienteId(value);
      setSedeId("");
      setAreaId("");
      return;
    }
    if (name === "sede") {
      setSedeId(value);
      setAreaId("");
      return;
    }
    if (name === "area") setAreaId(value);
  };

  // 📄 Generar reporte
  const handleGenerarReporte = async () => {
    if (!clienteId) {
      toast.warning("Seleccione un cliente para continuar");
      return;
    }

    setIsLoading(true);
    try {
      const params = new URLSearchParams();
      params.append("clienteId", clienteId);
      if (sedeId && sedeId !== "all") params.append("sedeId", sedeId);
      if (areaId && areaId !== "all") params.append("areaId", areaId);

      const res = await axios.get(
        `${API}/reportes/calendario?${params.toString()}`,
        {
          headers: { Authorization: `Bearer ${token}` },
          responseType: "blob",
        },
      );

      const blob = new Blob([res.data], { type: "application/pdf" });
      const link = document.createElement("a");
      link.href = window.URL.createObjectURL(blob);
      link.download = "reporte_cronograma.pdf";
      link.click();

      toast.success("Reporte generado correctamente ✅");
      onClose();
    } catch (err) {
      toast.error("Error al generar el reporte");
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/40 px-4">
      <div className="w-full max-w-2xl max-h-[90vh] bg-white rounded-2xl shadow-lg overflow-hidden flex flex-col">
        {/* Header */}
        <div className="px-6 py-4 border-b">
          <h2 className="text-xl font-semibold text-gray-800">
            Generar Reporte de Cronograma
          </h2>
        </div>

        {/* Scroll interno */}
        <div className="flex-1 overflow-y-auto">
          <div className="p-6 space-y-4">
            <SelectField
              label="Cliente"
              name="cliente"
              value={clienteId}
              options={clientes}
              onChange={handleChange}
              displayFn={(c) => `[${c.nit}] ${c.name}`}
            />

            {clienteId && (
              <SelectField
                label="Sede"
                name="sede"
                value={sedeId}
                options={sedes}
                onChange={handleChange}
              />
            )}

            {sedeId && (
              <SelectField
                label="Área"
                name="area"
                value={areaId}
                options={areas}
                onChange={handleChange}
                displayFn={(a) =>
                  a.grupo ? `${a.grupo.name} - ${a.name}` : a.name
                }
              />
            )}
          </div>
        </div>

        {/* Footer */}
        <div className="flex justify-end gap-2 p-6 border-t">
          <Button variant="outline" onClick={onClose}>
            Cancelar
          </Button>
          <Button
            onClick={handleGenerarReporte}
            disabled={isLoading}
            className="bg-blue-600 text-white hover:bg-blue-700"
          >
            {isLoading ? "Generando..." : "Generar Reporte"}
          </Button>
        </div>
      </div>
    </div>
  );
};

export default ModalReporteCronograma;
